import React, { useEffect, useState, } from 'react'
import classNames from 'classnames'
import Select from 'react-select'
import Typography from '@material-ui/core/Typography'
import TextField from '@material-ui/core/TextField'
import Paper from '@material-ui/core/Paper'
import Chip from '@material-ui/core/Chip'
import MenuItem from '@material-ui/core/MenuItem'
import CancelIcon from '@material-ui/icons/Cancel'
import PropTypes from 'prop-types'
import { emphasize } from '@material-ui/core/styles/colorManipulator'
import { makeStyles } from '@material-ui/styles'
import { fetchGateManagers, } from 'firebaseHelpers/users'

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    marginBottom: theme.spacing(3),
  },
  input: {
    display: 'flex',
    padding: 0,
    height: 'auto',
  },
  valueContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    flex: 1,
    alignItems: 'center',
    overflow: 'hidden',
  },
  chip: {
    margin: theme.spacing(0.5, 0.25),
  },
  chipFocused: {
    backgroundColor: emphasize(
      theme.palette.type === 'light' ? theme.palette.grey[300] : theme.palette.grey[700],
      0.08,
    ),
  },
  noOptionsMessage: {
    padding: theme.spacing(1, 2),
  },
  singleValue: {
    fontSize: 16,
  },
  placeholder: {
    position: 'absolute',
    left: 2,
    bottom: 6,
    fontSize: 16,
  },
  paper: {
    position: 'absolute',
    zIndex: 1301,
    marginTop: theme.spacing(1),
    left: 0,
    right: 0,
  },
  divider: {
    height: theme.spacing(2),
  },
}))

const NoOptionsMessage = (props) => {
  return (
    <Typography
      color="textSecondary"
      className={props.selectProps.classes.noOptionsMessage}
      {...props.innerProps}
    >
      {props.children}
    </Typography>
  );
}

const inputComponent = ({ inputRef, ...props }) => {
  return <div ref={inputRef} {...props} />;
}

const Control = (props) => {
  return (
    <TextField
      fullWidth
      InputProps={{
        inputComponent,
        inputProps: {
          className: props.selectProps.classes.input,
          inputRef: props.innerRef,
          children: props.children,
          ...props.innerProps,
        },
      }}
      {...props.selectProps.textFieldProps}
    />
  );
}

const Option = (props) => {
  return (
    <MenuItem
      buttonRef={props.innerRef}
      selected={props.isFocused}
      component="div"
      style={{
        fontWeight: props.isSelected ? 500 : 400,
      }}
      {...props.innerProps}
    >
      {props.children}
    </MenuItem>
  );
}

const Placeholder = (props) => {
  return (
    <Typography
      color="textSecondary"
      className={props.selectProps.classes.placeholder}
      {...props.innerProps}
    >
      {props.children}
    </Typography>
  );
}

const SingleValue = (props) => {
  return (
    <Typography className={props.selectProps.classes.singleValue} {...props.innerProps}>
      {props.children}
    </Typography>
  );
}

const ValueContainer = (props) => {
  return <div className={props.selectProps.classes.valueContainer}>{props.children}</div>;
}

const MultiValue = (props) => {
  return (
    <Chip
      tabIndex={-1}
      label={props.children}
      className={classNames(props.selectProps.classes.chip, {
        [props.selectProps.classes.chipFocused]: props.isFocused,
      })}
      onDelete={props.removeProps.onClick}
      deleteIcon={<CancelIcon {...props.removeProps} />}
    />
  );
}

const Menu = (props) => {
  return (
    <Paper square className={props.selectProps.classes.paper} {...props.innerProps}>
      {props.children}
    </Paper>
  );
}

const components = {
  Control,
  Menu,
  MultiValue,
  NoOptionsMessage,
  Option,
  Placeholder,
  SingleValue,
  ValueContainer,
}

const GateManagersPicker = props => {
  const { inputName, handleGateManagersChange, gateManagers, } = props;

  const classes = useStyles();

  const [gateManagersSugestion, setGateManagersSuggestion] = useState([])
  // const [isLoading, setIsLoading] = useState(false)

  const handleChange = (updatedGateManagers) => {
    handleGateManagersChange(updatedGateManagers ? updatedGateManagers.map((elem) => (elem.value)) : [])
  }

  useEffect(() => {
    let isMounted = true

    const fetchData = async () => {
      try {
        // setIsLoading(true)
        const gateManagersFetched = await fetchGateManagers()
        if (isMounted) {
          // setIsLoading(false)
          setGateManagersSuggestion(gateManagersFetched.map((gateManager) => ({ label: gateManager.email, value: gateManager.id })))
        }
      } catch (error) {
      }
    }
    fetchData()

    return () => {
      isMounted = false
    }
  }, [])

  const formatedGateManagers = gateManagersSugestion && gateManagers.length ? gateManagers.map((gateManagerId, index) => {
    const foundGateManagerIndex = gateManagersSugestion.findIndex((suggestion) => (suggestion.value === gateManagerId))

    return {
      value: foundGateManagerIndex !== -1 ? gateManagersSugestion[foundGateManagerIndex].value : gateManagerId,
      label: foundGateManagerIndex !== -1 ? gateManagersSugestion[foundGateManagerIndex].label : 'Unknown',
    }
  }) : []

  return (
    <div className={classes.root}>
      <Select
        classes={classes}
        // styles={selectStyles}
        textFieldProps={{
          label: inputName,
          InputLabelProps: {
            shrink: true,
          },
        }}
        options={gateManagersSugestion}
        components={components}
        value={formatedGateManagers}
        onChange={handleChange}
        placeholder="Select the gate managers for this parking"
        isMulti
      />
    </div>
  )
}

GateManagersPicker.propTypes = {
  inputName: PropTypes.string,
  handleGateManagersChange: PropTypes.func,
  gateManagers: PropTypes.arrayOf(PropTypes.string),
};

export default GateManagersPicker
